var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pp)?_c('FormCard',{attrs:{"config":_vm.imgs_data},on:{"DataSaved":_vm.UpdateData}}):_c('div',{staticClass:"loading"},[_c('CSpinner',{attrs:{"color":"secondary","size":"lg"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }